import { Select, TextInput, NumberInput, Text, Line, Snack, Div } from "@tblabs/truffle";
import { Expanse } from "../../Models/Expanse";
import { Icons } from "../../Components/Utils/Icons";
import { XDangerButton } from "../../Components/Utils/XDangerButton";
import { XPrimaryButton } from "../../Components/Utils/XPrimaryButton";
import { DateTimeEditInput } from "../../Components/Utils/DateSlider";
import { Page } from "../Page";
import { TableViewer } from "../../Components/TableViewer";
import { ExpansesProvider } from "./ExpansesProvider";


export class ExpensesPage extends Page
{
    constructor(private _exp: ExpansesProvider)
    {
        super("Wydatki");

        this.Content(async (body) =>
        {
            const expanses = await this._exp.GetAll();

            body.Append(
                new TableViewer(expanses)
                    .AddColumn("Kategoria", x => new Select(x.Category, ["Części", "Reklama", "Prowizja Agentów", "Narzędzia", "Transport", "Inne"]))
                    .AddColumn("Wydatek", x => new TextInput(x.Description))
                    .AddColumn("Kwota", x => new NumberInput(x.Amount))
                    .AddColumn("Data", x => new DateTimeEditInput(x.When))
                    .AddColumn("", x => new XDangerButton("Usuń", Icons.Trash, () => this._exp.Remove(x)))
                    .Build(),
                new Div().Append(
                    "Suma: ", new Text(this._exp.Sum),
                ).Style("text-align: left; font-size: 1.5rem; font-weight: bold;"),
                new Line(),
                new XPrimaryButton("Dodaj wydatek", Icons.Plus, () => _exp.Add(new Expanse({ Description: "", Amount: 0, When: new Date() }))), 
                new XPrimaryButton("Zapisz zmiany", Icons.Save, async () =>
                {
                    await this._exp.Save();
                    new Snack("Zmiany zapisane");
                })
            );
        });
    }
}
